const useChangedTexture = (
  currentVariant,
  materials,
  materialNames,
  HandleUpdateTexture
) => {
  // Define a list of texture updates based on the current variant properties
  const updates = [];

  // Check for interior texture changes
  if (currentVariant?.interior) {
    updates.push({
      materialName: materialNames.interior_materials,
      finishToApply: currentVariant.interior,
    });
  }

  // Check for exterior texture changes
  if (currentVariant?.outer) {
    updates.push({
      materialName: materialNames.outer_materials,
      finishToApply: currentVariant.outer,
    });
  }

  // Check for hardware-related texture changes
  if (currentVariant?.hardware) {
    materialNames.hardware_materials.forEach((materialName) => {
      updates.push({
        materialName: materialName,
        finishToApply: currentVariant.hardware,
      });
    });
  }

  // Apply the texture updates
  updates.forEach((update) => HandleUpdateTexture(update, materials));
};

export default useChangedTexture;
